import { ReportingChannelType } from '../../types/reportingChannelType';

export const DEFAULT_REPORTED_CHANNELS = [ReportingChannelType.IMPRESSION];
